import React from 'react'
import Select from 'react-select';
import { showSuccessMsg} from '../../util/messagesUtil';


export class ModalImportarConfiguracaoBPe extends React.Component {
  constructor(props) {
    super(props);
    this.state={empresaReferencia: null}
  }
  
  handleEmpresaChange(empresaReferencia){
    this.setState({empresaReferencia: empresaReferencia})
  }
  
  importarConfiguracaoBPe(){
    this.props.importarConfiguracaoBPe(this.state.empresaReferencia.value, this.props.codigoEmpresaSelecionada)
      .then(() => {
        this.props.buscarConfiguracoesBPe(this.props.codigoEmpresaSelecionada)
        showSuccessMsg('Importaçao realizada.')
      })
    
  }
  render () {
    return (
      <div className="modal fade show" id='modalImportarConfiguracaoBPe' role='dialog'
           aria-labelledby='modalImportarConfiguracaoBPe' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              {/* eslint-disable-next-line no-undef */}
              <h5>Importar configurações de uma empresa</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-8 mb-3">
                  <Select
                    maxMenuHeight={400}
                    menuPlacement="auto"
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione uma empresa'
                    options={this.props.empresas.map(elemento => ({
                      label: elemento.nomeFantasia,
                      value: elemento.id
                    }))}
                    value={this.state.empresaReferencia ? ({
                      label: this.state.empresaReferencia.label,
                      value: this.state.empresaReferencia.id
                    }) : ''}
                    onChange={value => this.handleEmpresaChange(value)}
                  />
                </div>
                <div className="col-3">
                  <button type='button' onClick={()=>this.importarConfiguracaoBPe()}
                         
                          className="btn btn-laranja">
                    IMPORTAR
                  </button>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    )
  }
}

export default (ModalImportarConfiguracaoBPe);
